import React, { useState } from 'react';
import DownArrowSvg from '../../searchLocation/priceFilter/assets/DownArrowSvg';
import OutsideClickHandler from '../../utils/OutsideClickHandler';
import {
  Dropdown,
  DropdownItemSelector,
  Icon,
  Input,
  Label,
  SelectInputWrapper,
} from './SelectInput.style';

function SelectInput({
  options,
  selectedOptionKey,
  onSelect,
  labelText,
  qaHook,
  isMobile,
}: Props): React.ReactElement {
  const selectedOption = options.find(
    (option) => option.key === selectedOptionKey,
  );
  const [isDropdownOpened, setDropdownOpened] = useState(false);

  return (
    <>
      {isMobile && <Label>{labelText}</Label>}
      <SelectInputWrapper>
        <Input
          data-test={`${qaHook}-input`}
          placeholder={labelText}
          value={selectedOption?.name ?? ''}
          onClick={(e) => {
            setDropdownOpened(!isDropdownOpened);
            e.stopPropagation();
          }}
          isMobile={isMobile}
          readOnly
        />
        <Icon>
          <DownArrowSvg />
        </Icon>
        <OutsideClickHandler
          isHandlerDisabled={!isDropdownOpened}
          onClickOutside={() => setDropdownOpened(false)}
        >
          <Dropdown isShow={isDropdownOpened} isMobile={isMobile}>
            {options.map((option) => (
              <DropdownItemSelector
                data-test={`${qaHook}-selector-${option.key}`}
                key={option.key}
                onClick={() => {
                  setDropdownOpened(false);
                  onSelect(option.key);
                }}
              >
                {option.name}
              </DropdownItemSelector>
            ))}
          </Dropdown>
        </OutsideClickHandler>
      </SelectInputWrapper>
    </>
  );
}

interface Props {
  options: {
    key: string;
    name: string;
  }[];
  labelText: string;
  selectedOptionKey: string;
  onSelect: (key: string) => void;
  qaHook: string;
  isMobile: boolean;
}

export default SelectInput;
